import React, { FC } from 'react';

import { BcAlert } from '@britishcouncil/react-solas-ors3';

export const SuccessMsg: FC<{ email?: string }> = ({ email }) => (
  <BcAlert type="success">
    {email ? (
      <p>Invitation email was successfully sent to {email}</p>
    ) : (
      <p>The registration confirmation was sent. Please check your inbox to activate your account.</p>
    )}
  </BcAlert>
);
